<template>
  <Transition name="operation-status">
    <aside
      v-if="activity.visible"
      class="operation-status"
      :class="[`is-${activity.category}`, { 'is-error': activity.failed }]"
      role="status"
      aria-live="polite"
    >
      <div class="operation-icon">
        <span v-if="!activity.failed" class="operation-spinner"></span>
        <i v-else class="bx bx-error-circle"></i>
      </div>
      <div class="operation-copy">
        <strong>{{ activity.title }}</strong>
        <p>{{ activity.message }}</p>
        <small v-if="activity.active && activity.elapsed >= 3">
          A processar há {{ activity.elapsed }} segundos
        </small>
      </div>
      <button
        v-if="activity.failed"
        type="button"
        aria-label="Fechar mensagem"
        @click="dismiss"
      >
        ×
      </button>
    </aside>
  </Transition>
</template>

<script>
import { requestActivity } from "@/services/requestActivity";

export default {
  name: "OperationStatus",
  computed: {
    activity() {
      return requestActivity.state;
    },
  },
  methods: {
    dismiss() {
      requestActivity.dismiss();
    },
  },
};
</script>

<style scoped>
.operation-status {
  position: fixed;
  z-index: 12000;
  top: 22px;
  right: 22px;
  display: grid;
  grid-template-columns: 42px minmax(220px, 380px) auto;
  gap: 13px;
  align-items: start;
  max-width: min(470px, calc(100vw - 32px));
  padding: 16px 17px;
  border: 1px solid #cfe7f3;
  border-radius: 16px;
  color: #10213b;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 18px 50px rgba(11, 52, 83, 0.2);
  backdrop-filter: blur(14px);
}
.operation-icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 12px;
  color: #087fae;
  background: #e7f8fd;
  font-size: 24px;
}
.operation-spinner {
  width: 21px;
  height: 21px;
  border: 3px solid #b9e8f4;
  border-top-color: #0788ba;
  border-radius: 50%;
  animation: operation-spin 0.75s linear infinite;
}
.operation-copy strong { display: block; margin: 1px 0 4px; font-size: 14px; }
.operation-copy p { margin: 0; color: #53677a; font-size: 12px; line-height: 1.5; }
.operation-copy small { display: block; margin-top: 7px; color: #7a8a99; font-size: 10px; }
.operation-status button { padding: 0; border: 0; color: #758495; background: transparent; font-size: 23px; line-height: 1; }
.operation-status.is-error { border-color: #f1c9c9; }
.operation-status.is-error .operation-icon { color: #c83b3b; background: #fff0f0; }
.operation-status.is-agt { border-left: 5px solid #e69b16; }
.operation-status.is-network { border-left: 5px solid #d94b4b; }
.operation-status.is-timeout { border-left: 5px solid #d88717; }
.operation-status.is-device { border-left: 5px solid #7865cc; }
@keyframes operation-spin { to { transform: rotate(360deg); } }
.operation-status-enter-active, .operation-status-leave-active { transition: opacity 0.22s ease, transform 0.22s ease; }
.operation-status-enter-from, .operation-status-leave-to { opacity: 0; transform: translateY(-12px); }
@media (max-width: 600px) {
  .operation-status { top: 12px; right: 12px; left: 12px; grid-template-columns: 38px 1fr auto; max-width: none; }
}
</style>
